import { render, staticRenderFns } from "./Await.vue?vue&type=template&id=4a9e4599&"
import script from "./Await.vue?vue&type=script&lang=ts&"
export * from "./Await.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports